<template>
  <div
    class="custom-group-tours-faq-card"
    :class="{
      active: isExpand,
      'bd-b-1 bd-gray-branding': !isExpand,
    }"
  >
    <div
      class="pa-16 sd-5 br-12 mb-8 hand"
      :class="{
        'sd-none': !isExpand,
      }"
      @click="expand"
    >
      <div class="mb-10 flex items-center justify-between">
        <h3
          class="fs-20 fw-700 lh-28 ls-1"
          :class="{
            'gray-dark': !isExpand,
          }"
          v-html="question"
        ></h3>
        <img
          :src="
            isExpand
              ? `${ASSETS_CDN}/icons/arrow_up.svg`
              : `${ASSETS_CDN}/icons/arrow_down.svg`
          "
          :alt="isExpand ? 'down' : 'up'"
        />
      </div>
      <Transition name="fade">
        <p v-show="isExpand" class="fw-500 fs-16 lh-22 mb-0 answer">
          {{ answer }}
        </p>
      </Transition>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'

import {assetCDN} from '~/helper/index.js'


// eslint-disable-next-line no-undef
const props = defineProps({
  question: {
    type: String,
    default: 'What do you need from me to start designing a Private Group Tour?',
  },
  answer: {
    type: String,
    default: `To start designing a Private Group Tour, we need as much detail as possible through the enquiry form. Please provide us with the estimated group size, preferred departure month, budget guidelines, any special requirements, and, if available, sample itineraries or links to preferred tours. This information allows us to create a tailored itinerary that aligns with your group's needs, preferences, and required experience. The more detail you can provide in the initial enquiry, the better, and quicker, we can start designing the best trip for you!`,
  },
  shouldOpen: {
    type: Boolean,
    default: false,
  }
})

const ASSETS_CDN = assetCDN()

const isExpand = ref(props.shouldOpen)
const expand = () => {
  isExpand.value = !isExpand.value
}

watch(()=> props.shouldOpen, (v)=>isExpand.value = v)
// onMounted(() => {
//   isExpand.value = props.shouldOpen
// })
</script>

<style lang="scss" scoped></style>
